<template>
  <!-- <div class="kt-widget4">
    <div class="kt-widget4__head kt-margin-b-40">
      <div class="kt-widget4__item">
        <span class="kt-widget4__title kt-font-bold">Service</span>
        <span class="kt-widget4__number kt-font-bold">Total</span>
      </div>
    </div>
    <div class="kt-widget4__body">
      <div v-for="(column, idx) in projectRequestTotal" :key="idx" class="kt-widget4__item">
        <span class="kt-widget4__title kt-widget4__title--light">
          {{ column.service }}
        </span>
        <span class="kt-widget4__number kt-font-info">{{ column.total | number }}</span>
      </div>
    </div>
  </div> -->

  <div class="tab-content">
    <!--begin::tab 1 content-->
    <div id="kt_widget11_tab1_content" class="tab-pane active">
      <!--begin::Widget 11-->
      <div class="kt-widget11">
        <div class="table-responsive">
          <table class="table kt-align-center">
            <thead>
              <tr>
                <td style="width:14%">
                  Service
                </td>
                <td style="width:15%">
                  Total
                </td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(column, idx) in projectRequestTotal" :key="idx">
                <td>{{ column.service }}</td>
                <td class=" kt-font-brand  kt-font-bold">
                  {{ column.total | number }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!--end::Widget 11-->
    </div>
    <!--end::tab 1 content-->

    <!--begin::tab 2 content-->
    <div id="kt_widget11_tab2_content" class="tab-pane">
      <!--begin::Widget 11-->
      <div class="kt-widget11">
        <div class="table-responsive">
          <table class="table kt-align-center">
            <thead>
              <tr>
                <td style="width:14%">
                  Service
                </td>
                <td style="width:15%">
                  Total
                </td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(column, idx) in projectRequestTotal" :key="idx">
                <td>{{ column.service }}</td>
                <td class=" kt-font-brand  kt-font-bold">
                  {{ column.total | number }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!--end::Widget 11-->
    </div>
    <!--end::tab 2 content-->
    <!--begin::tab 3 content-->
    <div id="kt_widget11_tab3_content" class="tab-pane" />
    <!--end::tab 3 content-->
  </div>
</template>

<script>
import numeral from 'numeral'

export default {
  name: 'ProjectRequestTable',
  filters: {
    number (value) {
      if (value) {
        return numeral(value).format('0,0')
      } else {
        return value
      }
    }
  },
  props: { projectTotal: Array },
  data () {
    return {
      projectRequestTotal: []
    }
  },
  watch: {
    projectTotal () {
      this.getProjectRequestTotal()
    }
  },
  mounted () {
    this.getProjectRequestTotal()
  },
  methods: {
    getProjectRequestTotal () {
      const projectTotalData = this.projectTotal
      const totalService = []
      if (projectTotalData) {
        for (const data of projectTotalData) {
          totalService.push({
            service: data.service.substring(5),
            total: data.total
          })
        }
        this.projectRequestTotal = totalService
      }
    }
  }
}
</script>
